export default __webpack_public_path__ + "static/king-2f5d5b8ad24fe00d6bdc32c0e462e24f49974aba48f5fe161e4d7f2fda54b44f.png";